function formatMoney(number) {
    number = number.toFixed(2);
    return number.toLocaleString('nl-NL');
}

export default {formatMoney};